import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../flux';
import { images, texts } from '../../settings';
import { DelayLink } from '../../components';

import './SobreRelatorio.scss';

class SobreRelatorio extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,

      loaderBarWidth: 0,
      loaderBarIndex: 0,
      intervalBar: 0,
    };

    this.images = images;
    this.texts = texts;

    this.contentText = React.createRef();
    this.runTransition = this.runTransition.bind(this);

    this.startLoader = this.startLoader.bind(this);
    this.loaderBar = this.loaderBar.bind(this);
  }

  scrollTop() {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  runTransition() {
    Actions.globalTransition();
  }

  loaderBar() {
    const { loaderBarIndex } = this.state;
    let index = loaderBarIndex;
    index++;
    if (index <= 100) {
      this.setState({
        loaderBarIndex: index,
        loaderBarWidth: index + '%',
      });
    } else {
      clearInterval(this.state.intervalBar);
    }
  }

  startLoader() {
    this.setState({ loaderBarIndex: 0 });
    var intervalBar = setInterval(this.loaderBar, percent);
    this.setState({ intervalBar: intervalBar });
  }

  componentDidMount() {
    Actions.headerIntern();
    this.scrollTop();
  }

  render() {
    const { loaderBarWidth } = this.state;

    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Sobre o Relatório - {this.texts.title}</title>
        </Helmet>

        {/* <div className="parallax-image">
          <img src={this.images.sobre_relatorio.first_bg} />
        </div> */}

        <div className="sobre-relatorio page-gradient--blue-sobre bg-light-blue" ref="sobre-relatorio">
          <section className="sobre-relatorio-area page-gradient__header page--blue bg-size">
            <div className="container">
              <div className="row">
                <div class="container white">
                  <h1 className="page-header__title gri_text gri_text--fixed">
                    <img src={images.sobre_relatorio.shape} className="shape" />
                    Sobre o relatório
                    <span className="gri_label">
                      GRI <b>102-13, 102-42, 102-43, 103-1, 103-2, 103-3 | 203</b>
                    </span>
                  </h1>
                </div>
                <div className="col-12 mx-0">
                  <Fade bottom>
                    <div className="card card--page-body card--blue h-topo">
                      <div className="card__content">
                        {/* <div className="card__content__header">
                          <h1 className="title">Sobre o relatório</h1>
                        </div> */}
                        <div className="card__content__body">
                          <p className="gri_text gri_text_sobre_relatorio">
                            Esta edição, assim como as três anteriores, é inspirada na versão Standards, opção Essencial
                            da GRI (Global Reporting Initiative), principal metodologia internacional para relatos de
                            sustentabilidade. Nela constam informações sobre nosso perfil, governança, estratégia,
                            equipe interna, bem como as principais iniciativas que realizamos entre 1º de janeiro e 31
                            de dezembro de 2020, de acordo com o nosso plano de ação anual.
                            <br />
                            <span className="gri_label">
                              GRI <b>102-46, 102-50, 102-52, 102-54</b>
                            </span>
                          </p>
                          <p className="gri_text gri_text_sobre_relatorio">
                            É este plano, construído com a colaboração do mercado, que define os temas prioritários. Ou
                            seja, não se trata de um processo formatado de acordo com uma metodologia voltada para o
                            relato, mas sim um plano de trabalho. Além disso, nossos fóruns de representação nos
                            permitem ouvir constante e plenamente o mercado e identificar o que ele espera da atuação da
                            ANBIMA. Também são feitas consultas periódicas com outros stakeholders, como reguladores
                            (CVM e Banco Central) e população economicamente ativa, por meio da pesquisa anual Raio X do
                            Investidor Brasileiro.
                            <br />
                            <span className="gri_label">
                              GRI <b>102-42, 102-43</b>
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="card__image">
                        <img src={images.sobre_relatorio.second_bg} className="h-img" />
                        <img src={images.sobre_relatorio.bg_text_mobile} className="h-img-mobile" />
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
          <div className="row container">
            <Fade bottom>
              <div className="sobre-relatorio-duvidas">
                <div className="sobre-relatorio-duvidas__container">
                  <div className="sobre-relatorio-duvidas__text">
                    <p>
                      Se ficou com dúvidas sobre o conteúdo deste relatório, quer fazer sugestões ou solicitar mais
                      informações, pode entrar em contato com a gente pelo e-mail
                    </p>
                    <a href="mailto:imprensa@anbima.com.br">imprensa@anbima.com.br</a>
                    <span className="gri_label">
                      GRI <b>102-53</b>
                    </span>
                  </div>
                  <div className="anima-duvida">
                    <img src={images.sobre_relatorio.duvidas} className="duvidas" />
                    <img src={images.sobre_relatorio.pessoa} className="pessoa" />
                    <img src={images.sobre_relatorio.int1} className="int1" />
                    <img src={images.sobre_relatorio.int2} className="int2" />
                    <img src={images.sobre_relatorio.int3} className="int3" />
                  </div>
                </div>
              </div>
            </Fade>
          </div>

          <section className="creditos-area bg-light-blue">
            <div className="container bg-white px-2">
              <div className="row">
                <div className="col-12 creditos-area__title">
                  <Fade bottom>
                    <h1>
                      Conheça quem fez
                      <br /> esta publicação:
                    </h1>
                  </Fade>
                </div>

                <div className="col-4-sobre-relatorio">
                  <Fade bottom>
                    <div className="card card--blue">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <img src={this.images.sobre_relatorio.icon_gerencia} className="card__icon" />
                          <h3 className="title title--small">Marcelo Billi</h3>
                        </div>
                        <div className="card__content__body">
                          <p>Gerência de Comunicação e Marketing</p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                <div className="col-4-sobre-relatorio">
                  <Fade bottom>
                    <div className="card card--blue">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <img src={this.images.sobre_relatorio.icon_coord_conteudo} className="card__icon" />
                          <h3 className="title title--small">Marineide Marques</h3>
                        </div>
                        <div className="card__content__body">
                          <p>Coordenação de comunicação</p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                <div className="col-4-sobre-relatorio">
                  <Fade bottom>
                    <div className="card card--blue">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <div className="footer-logo-grupo-report">
                            <img src={this.images.sobre_relatorio.icon_redacao} className="card__icon" />
                            {/* <h3 className="title title--small">Grupo Report</h3> */}

                            <img src={this.images.sobre_relatorio.logo_grupo_report} />
                          </div>
                        </div>
                        <div className="card__content__body">
                          <p>Redação</p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                <div className="col-4-sobre-relatorio">
                  <Fade bottom>
                    <div className="card card--blue">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <img src={this.images.sobre_relatorio.icon_coord_digital} className="card__icon" />
                          <h3 className="title title--small">Victor Villa</h3>
                        </div>
                        <div className="card__content__body">
                          <p>Apoio técnico</p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                <div className="col-4-sobre-relatorio">
                  <Fade bottom>
                    <div className="card card--blue">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <img src={this.images.sobre_relatorio.icon_edicao} className="card__icon" />
                          <h3 className="title title--small">Carlos Oliveira</h3>
                        </div>
                        <div className="card__content__body">
                          <p>Edição digital</p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                <div className="col-4-sobre-relatorio">
                  <Fade bottom>
                    <div className="card card--blue">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <img src={this.images.sobre_relatorio.icon_projeto} className="card__icon" />
                          <h3 className="title title--small">
                            <img src={this.images.sobre_relatorio.logo_creditos_fullbar} />
                          </h3>
                        </div>
                        <div className="card__content__body">
                          <p>Projeto digital</p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="sobre-footer-area">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <div className="box-pill box-pill--green box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-12 col--text">
                            <h4>Entenda o sumário de conteúdo GRI</h4>
                            <DelayLink
                              to="/sumario-gri"
                              className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Saiba mais
                            </DelayLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export { SobreRelatorio };
